<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Aclonica&display=swap" rel="stylesheet">

<!-- title screen -->
<div *ngIf="this.DungeonPathService.showTitleScreen === true" class="title-container">

    <div  *ngIf="this.isTitleDismissed === false" class="title" (click)="dismissTitle()">
        The Dungeon Path
    </div>

    <div *ngIf="this.isTitleDismissed === true" class="titleDialog" (click)="startGame()">
        You stumble away from the party to get some air and clear your head <br>
        coming across a cave entrance you see no harm in taking a look inside...
    </div>

    <div *ngIf="this.isTitleDismissed === true" >
        <img class="avatarTitle" src="assets/images/avatars/AvatarWon.png" />
    </div>

    <img class="cave-entrance-image" src="assets/images/backgrounds/backgroundentrance.png" />

</div>

<!-- game over screen -->
<div *ngIf="this.PlayerInventoryService.isPlayerDead === true" class="title-container">

    <div class="youDiedDialog">
        YOU DIED
    </div>

    <div class="flexrow">
        <button class="restart-button" (click)="resetAll()">Restart</button>
    </div>

    <div>
        <img class="avatarDead" src="assets/images/avatars/AvatarDead.png" />
    </div>

    <img class="cave-background-image" src="assets/images/backgrounds/background2.png" />

</div>


<!-- winner screen -->
<div *ngIf="this.PlayerInventoryService.isPlayerWon === true" class="title-container">

    <div class="youWonDialog">
        YOU WON
    </div>

    <div class="flexrow">
        <button class="restart-button" (click)="resetAll()">Restart</button>
    </div>

    <div>
        <img class="avatarWon" src="assets/images/avatars/AvatarWon.png" />
    </div>

    <img class="cave-win-image" src="assets/images/backgrounds/backgroundexit.png" />

</div>